// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3BwEq","productName":"Table_productName__3eGGk"};